export const TrinitySearchTypes = {
  TRINITY_SEARCH_NEWS_DATA: 'TRINITY_SEARCH_NEWS_DATA',
  LAST_SEARCH_DATA: 'LAST_SEARCH_DATA',
};
